class AdditionalInfoTableUpdater {
  constructor() {
    this.onVariantUpdated = this.onVariantUpdated.bind(this);
    document.addEventListener('variant:updated', this.onVariantUpdated);
  }

  onVariantUpdated({detail}) {
   if (!detail?.variantId || !window.originalVariantsData) {
      return;
    }
    const variantId = detail.variantId;
    const variant = getVariantById(window.originalVariantsData, variantId);
    if (!variant) {
      return;
    }
    this.updateAdditionalInfoTable(variant);
  }

  updateAdditionalInfoTable(variant) {
    if (!variant) {
      return;
    }

    const table = document.querySelector('table.additional-info-table');
    if (!table) {
      return;
    }

    const setTextById = (id, value) => {
      if (!id) {
        return;
      }
      const el = document.getElementById(id);
      if (!el) {
        return;
      }
      if (value === null || value === undefined || value === '') {
        return;
      }
      el.textContent = value;
    };

    if (typeof variant.sku === 'string') {
      setTextById('info-sku', variant.sku);
    }
    const conditionLabel = variant.condition_label || variant.conditionLabel || variant.condition;
    if (typeof conditionLabel === 'string') {
      setTextById('info-condition', conditionLabel);
    }

    setTextById('info-isbn13', variant.ean || variant.isbn13 || '');
    setTextById('info-isbn10', variant.isbn10 || '');
    setTextById('info-binding-type', variant.bindingType || variant.binding_type || '');
    setTextById('info-publisher', variant.publisher || '');
    setTextById('info-year-published', variant.yearPublished || '');
    setTextById('info-number-of-pages', variant.numberOfPages || '');

    const seriesEl = document.getElementById('info-series');
    if (seriesEl) {
      const series = variant.seriesCollection;
      if (series?.title && series.handle) {
        if (seriesEl.tagName === 'A') {
          seriesEl.href = `/collections/${series.handle}`;
          seriesEl.textContent = series.title;
        } else {
          seriesEl.innerHTML = '';
          const a = document.createElement('a');
          a.href = `/collections/${series.handle}`;
          a.textContent = series.title;
          seriesEl.appendChild(a);
        }
      } else if (variant.seriesTitle) {
        seriesEl.textContent = variant.seriesTitle;
      }
    }
  }
}

// Bootstrap only if tables exist
document.addEventListener('DOMContentLoaded', () => {
  const tables = document.querySelectorAll('table.additional-info-table');
  if (tables && tables.length > 0) {
    new AdditionalInfoTableUpdater();
  }
});
